// $(".submenu-container--links .left-links ul li a").on("mouseover", function () {
//   const link = $(this).attr('data-link');

//   $('.right-links ul').hide();
//   $('.right-links ul[data-menu="'+link+'"]').css('display', 'flex');
// });

$('.product__image_with_text--acc .faq-body-c').click(function () {
    $(this).find(".faq-answer").slideToggle(400);
    $(this).toggleClass("active");
});

$(".popup").find(".popup-btn").click(function(e){
    e.preventDefault();
    $(this).closest(".popup").find(".popup_div").css({"display": "flex"});
})

$(".popup").find(".cross_btn").click(function(){
    $(this).closest(".popup_div").css({"display": "none"});
})

if ($(window).width() < 778) {
    $(".faq-body").click(function () {
      $(this).find(".faq-answer").slideToggle(400);
      $(this).toggleClass("active");
    });
}

if ($(window).width() > 778) {
    $(".accordion-body .accordion-title").click(function () {
    $(this).next().slideToggle(300);
    $(this).toggleClass("active");
    });
}

$(document).ready(function () {
    
    var setProductSpace = function () {
      if ($(window).width() > 1200) {
        const addedHeight = $(".product-information .product__content").height();
        $(".addToCart").css({ "top": addedHeight + 190 });
        $(".product-information").css({"min-height": addedHeight + 500});
      }else{
        $(".addToCart").css({ "top": "-10px" });
      }
    }
  
    $(window).on('load', setProductSpace);
    $(window).resize(setProductSpace);

    var setVideoHeight = function () {
      if ($(window).width() > 1200) {
      let imageHeight = $('.image-_video').find("#same-size").innerHeight();
      $(".image-_video").find("#do-same-size").css({"height": imageHeight});
      }
    }
    
    $(window).on('load', setVideoHeight);
    $(window).resize(setVideoHeight);

    if ($(".product_media_slider_desktop").length >= 1) {
      $(".product_media_slider_desktop").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrow: false,
      });
    }

    if ($(".product_media_slider_mobile").length >= 1) {
      $(".product_media_slider_mobile").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        asNavFor: ".product__content__mobile",
      });
    }

    if ($(".product__content__mobile").length >= 1) {
      $(".product__content__mobile").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".product_media_slider",
        arrow: false,
      });
    }

    $(".custom_number_nav li").click(goToSlide);
    $(".custom_scroller .bar").click(goToSlide);

    function goToSlide() {
      var goToThisIndex = $(this).data("slick-index");
      $(".product_media_slider").slick("slickGoTo", goToThisIndex, false);
    }

    $(".product_media_slider").on("init reInit beforeChange", setActive);

    function setActive(event, slick, currentSlide, nextSlide) {
      $(".custom_number_nav li").removeClass("active");
      $(".custom_scroller .bar").removeClass("active");
      
      $(`[target-id=slick-slide0${nextSlide}]`).addClass("active");
    }

});

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

if ($(window).width() < 768) {

    if($(".product-information").length) {
        var lastScrollTop = 0;
        var stickyOffset = $(".product-information").offset().top + $(".product-information").outerHeight(true) + 200;
        
        $(window).bind('scroll', function() {
            var st = $(window).scrollTop();

            lastScrollTop = st;

            if($(".product-form").length > 0){
                if(st > stickyOffset) {
                if ($('product-form').isInViewport()) {
                    $(".sticky-custom-form").removeClass("show");
                } else {
                    $(".sticky-custom-form").addClass("show");
                }
                } else {
                $(".sticky-custom-form").removeClass("show");
                }
            }
        
        });
    }
}